/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

export const TableColumns = [
  "visit_date",
  "visit_time",
  "created_date",
  "created_time",
  "created_lead_time",
  "cancelled_date",
  "no_show_date",
  "seated_date",
  "finished_date",
  "last_updated",
  "actual_duration",
  "guest_name",
  "phone_number",
  "email",
  "marketing_opt_in",
  "company",
  "birthday",
  "anniversary",
  "size",
  "status",
  "table",
  "table_type",
  "dining_area_assigned",
  "dining_area_booked",
  "source",
  "online_channel",
  "partner",
  "open_table_boost_type",
  "campaign_details",
  "restref_source",
  "restref_campaign_name",
  "turn_time_setting",
  "online_waitlist",
  "quoted_wait_time",
  "total_wait_time",
  "created_by",
  "server",
  "referrer_name",
  "referrer_business",
  "restref_field",
  "experience_title",
  "experience_type",
  "experience_subtotal",
  "addons_subtotal",
  "experience_total_revenue",
  "service_charges",
  "service_gratuity",
  "experience_tax",
  "experience_total_income",
  "pos_revenue",
  "pos_gratuity",
  "pos_check_fields",
  "prepayment_method",
  "prepayment_status",
  "prepayment_required_total",
  "prepayment_paid_total",
  "prepayment_refunded_total",
  "payment_processor_payout_date",
  "payment_processor_transaction_fee",
  "opentable_service_fee",
  "opentable_boost_fee",
  "total_revenue",
  "total_gratuity",
  "guest_requests",
  "visit_notes",
  "reservation_tags",
  "guest_tags",
  "general_notes",
  "special_relationships",
  "seating_preferences",
  "food_drink_preferences",
  "first_visit_date",
  "recent_visit_date",
  "upcoming_visits",
  "completed_visits",
  "cancelled_count",
  "no_show_count",
  "lifetime_spend",
  "lifetime_per_cover_spend",
];
